import { Button, PanelRow } from '@wordpress/components';
import { useState } from '@wordpress/element';
import React from 'react';

const SidebarAutocompleteList = (props) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const [items, setItems] = useState(props.items);
    const [postId, setPostId] = useState(props.postId);

    const handleItemClick = (index) => {
        setSelectedItems((prevSelected) => {
            if (prevSelected.includes(index)) {
                props.onChangeSelectedItemsData(prevData => prevData.filter(item => item.id !== items[index].id));
                return prevSelected.filter(i => i !== index);
            } else {
                props.onChangeSelectedItemsData(prevData => [...prevData, items[index]]);
                return [...prevSelected, index];
            }
        });
    };

    const handleRemoveSelectedItem = (id) => {
        props.onChangeSelectedItemsData((prevData) => prevData.filter(item => item.id !== id));
        setSelectedItems((prevSelected) => prevSelected.filter(index => items[index].id !== id));
    };

    const handleButtonClickPDFMultipleItems = () => {
        if (props.selectedItemsData.length < 1) {
            return;
        }

        const selectedIds = props.selectedItemsData.map(item => item.id).join(',');
        const nonce = window.tainacanReportsNonces?.generate_report || '';
        if (!nonce) {
            return;
        }
        window.open(`/tainacan-report/generator/?reportId=${postId}&singleItem=${selectedIds}&pdf=true&_wpnonce=${nonce}`, '_blank');
    };

    return (
        <>
            {items.length > 0 && (
                <>
                    <PanelRow>
                        <ul style={{ marginTop: '10px', padding: 0 }}>
                            {items.map((suggestion, index) => (
                                <li
                                    key={index}
                                    style={{
                                        cursor: 'pointer',
                                        listStyle: 'none',
                                        padding: '5px',
                                        backgroundColor: selectedItems.includes(index) ? '#f7f7f7' : 'transparent',
                                        border: selectedItems.includes(index) ? '1px solid #007cba' : 'none',
                                    }}
                                    onClick={() => handleItemClick(index)}
                                >
                                    Doc: {suggestion?.metadata?.dcidentifier?.value} -
                                    Título: {suggestion.title} -
                                    Data: {suggestion?.metadata?.date?.value} -
                                    Autor(es): {suggestion?.metadata?.creator?.value?.map((creator) => creator.name).join(', ')}
                                </li>
                            ))}
                        </ul>
                    </PanelRow>

                    {props.selectedItemsData?.length > 0 && (
                        <PanelRow>
                            <div style={{
                                border: '1px solid #ccc',
                                padding: '10px',
                                width: '100%',
                                backgroundColor: '#f9f9f9',
                                borderRadius: '4px'
                            }}>
                                <strong>Itens Selecionados:</strong>
                                <ul style={{ listStyle: 'none', padding: 0 }}>
                                    {props.selectedItemsData.map((item) => (
                                        <li key={item.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0' }}>
                                            <span>{item.title}</span>
                                            <Button isSmall isDestructive onClick={() => handleRemoveSelectedItem(item.id)}>❌</Button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </PanelRow>
                    )}

                    <PanelRow>
                        <Button variant="primary" onClick={handleButtonClickPDFMultipleItems}>
                            Gerar relatório
                        </Button>
                    </PanelRow>
                </>
            )}
        </>
    );
};

export default SidebarAutocompleteList;
